
import Vue from 'vue';

export default Vue.extend({
  name: 'deleting-last-authenticator-app-modal',
});

